"use client";
import { BlockquoteComponent } from "@areahub/ui/marketing/blockquote-component";
import { PodcastNewsBrief } from "@areahub/ui/marketing/podcast-news-brief";
import { Box, Divider, Heading, Image, Stack, Text } from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { richTextRenderers } from "components/individuals/mdx-components";

export function CoverImageClient({ post }) {
  return (
    <>
      {post.coverImage && <Image src={post?.coverImage.url} w="100%" mb="4" />}
    </>
  );
}

export function PostContentClient({ post }) {
  return (
    <Stack
      flexDirection="column"
      flex="auto"
      alignItems="flex-start"
      px={{ base: "6", md: "8" }}
      maxW="100vw"
      overflowX="hidden"
    >
      <Box w={"full"}>
        <RichText
          content={post?.content?.json}
          references={post?.content?.references}
          renderers={{
            ...richTextRenderers,
            embed: {
              BlockquoteComponent: ({ description }) => (
                <BlockquoteComponent>
                  <RichText
                    content={description.raw}
                    renderers={richTextRenderers}
                  />
                </BlockquoteComponent>
              ),
              PodcastNewsBrief: ({ link }) => <PodcastNewsBrief link={link} />,
            },
          }}
        />
      </Box>
    </Stack>
  );
}

export function TitleClient({ post }) {
  const authorsLen = post?.authors?.length;
  const multipleAuthors = authorsLen > 0 ? true : false;
  return (
    <Box px={{ base: "6", md: "8" }}>
      {/* In some instances where we want to display the company's logo above a press article's title */}
      {post.companyLogo && (
        <Image src={post?.companyLogo.url} w="30%" mb="10" />
      )}
      <Heading
        as="h1"
        size="2xl"
        mb={post.subtitle ? "" : "5"}
        letterSpacing="unset"
      >
        {post.title}
      </Heading>
      {/* In some instances where we want the press article's title broken down into two lines */}
      {post.subtitle && (
        <Heading as="h1" size="2xl" mb="5" letterSpacing="unset">
          {post.subtitle}
        </Heading>
      )}
      {multipleAuthors ? (
        <Text fontWeight={"medium"}>
          <Box as="span" fontWeight={"normal"}>
            By:
          </Box>{" "}
          {post?.authors?.map((author, idx: number) => {
            /**
             * if there is an even number of authors, then add "and " after names with even indexes
             */
            const shouldAddSeparator = authorsLen % 2 === 0 && idx % 2 === 0;
            return (
              <Text key={`author-name-${idx}`} as="span">
                {author?.person?.name} {shouldAddSeparator ? "and " : ""}
              </Text>
            );
          })}
        </Text>
      ) : (
        <>
          {post?.author?.person?.name && (
            <Text fontWeight={"medium"}>
              <Box as="span" fontWeight={"normal"}>
                By:
              </Box>{" "}
              {post.author.person.name}
            </Text>
          )}
        </>
      )}
      <Divider my={5} />
    </Box>
  );
}
